import { render, staticRenderFns } from "./QuestionContinue.vue?vue&type=template&id=4427a4a3&scoped=true&"
import script from "./QuestionContinue.vue?vue&type=script&lang=js&"
export * from "./QuestionContinue.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContinue.vue?vue&type=style&index=0&id=4427a4a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427a4a3",
  null
  
)

export default component.exports